import { actionCreatorFactory } from 'typescript-fsa/lib';

const actionCreator = actionCreatorFactory('Config');

export const completeRehydration = actionCreator('REHYDRATION_COMPLETE');

export const stopAllLoaders = actionCreator('STOP_ALL_LOADERS');



// WEBPACK FOOTER //
// ./src/store/Config/config.actions.ts